import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { authGuard } from './core/guards/auth.guard';
import { layoutResolver } from './core/layout/resolver/layout-resolver.resolver';
import { AuthorizedGuard } from './core/guards/authorized.guard';
import { SettingsListComponent } from './modules/template/settings/pages/settings-list/settings-list.component';

const childrenRoutes: Routes = [
    {
        path: 'inicio',
        loadChildren: () =>
        import('./modules/template/my-board/my-board.routes').then((m) => m.MY_BOARD_ROUTES),
        canActivate: [authGuard, AuthorizedGuard],
        canLoad: [authGuard],
    },
    {
    path: 'common',
    loadChildren: () =>
      import('./core/common-pages/common-pages.routes').then(
        (m) => m.COMMON_PAGES_ROUTES
      ),
    canActivate: [authGuard],
    canLoad: [authGuard],
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('./modules/template/roles/roles.routes').then(
        (m) => m.ROLES_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'usuarios',
    loadChildren: () =>
      import('./modules/template/users/users.routes').then(
        (m) => m.USERS_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  // {
  //   path: 'coberturas',
  //   loadChildren: () =>
  //     import('./modules/generic-coverage/generic-coverage.routes').then(
  //       (m) => m.GENERIC_COVERAGE
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  // {
  //   path: 'planes',
  //   loadChildren: () =>
  //     import('./modules/plans/plans.routes').then(
  //       (m) => m.PLANS_ROUTES
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  // {
  //   path: 'red-clinicas',
  //   loadChildren: () =>
  //     import('./modules/clinic-network/clinic-network.routes').then(
  //       (m) => m.CLINIC_NETWORK_ROUTES
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  // {
  //   path: 'comisiones',
  //   loadChildren: () =>
  //     import('./modules/comissions-settings/comission-setting.routes').then(
  //       (m) => m.COMISSIONS_SETTINGS
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  // {
  //   path: 'productos',
  //   loadChildren: () =>
  //     import('./modules/products/products.routes').then(
  //       (m) => m.PRODUCTS_ROUTES
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  // {
  //   path: 'master',
  //   loadChildren: () =>
  //     import('./modules/main/main.routes').then(
  //       (m) => m.MASTER_ROUTES
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },


  
  {
    path: 'clientes',
    loadChildren: () =>
      import('./modules/clients/client.routes').then(
        (m) => m.CLIENT_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'cartas-garantia',
    loadChildren: () =>
      import('./modules/letter-guarantee/letter-guarantee.routes').then(
        (m) => m.LETTER_GUARANTEE_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'informes-medicos',
    loadChildren: () =>
      import('./modules/medical-reports/medical-reports.routes').then(
        (m) => m.MEDICAL_REPORTS_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'siniestros',
    loadChildren: () =>
      import('./modules/sinisters/sinisters.routes').then(
        (m) => m.SINISTER_ROUTES
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },



  // {
  //   path: 'configuraciones',
  //   loadChildren: () =>
  //     import('./modules/template/settings/setting.routes').then(
  //       (m) => m.SETTINGS_ROUTES
  //     ),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  {
    path: '**',
    redirectTo: 'common',
  },
]

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () =>
        import('./core/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    },
    {
        path: '',
        component: LayoutComponent,
        children: childrenRoutes,
        canActivate: [authGuard],
        resolve: {preferences: layoutResolver}
    },
];
